import { combineReducers } from "@reduxjs/toolkit";
import { enumSlice } from "./enum.slice";
import { projectVersionSlice } from "./project-version.slice";
import { themeSlice } from "./theme.slice";
import { authSlice } from "./auth.slice";


export const rootReducer = combineReducers({
  enum: enumSlice.reducer,
  theme: themeSlice.reducer,
  auth: authSlice.reducer,
  projectVersion: projectVersionSlice.reducer,
});
